export default __webpack_public_path__ + "static/cafe_36006-a7a53392a3daf4b82eb955bd72866c9d.png";